// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a8a849f8","455":"d3bab1da","977":"52599f41"}[chunkId] + ".chunk.js";
};